export default require.context('./static/', true, /^(\.\/.*\.js|\.\/.*\.cs{2})/)
